import { css } from 'styled-components';

import { media } from '~/theme';

export const ShowForMediumUp = css`
    display: none;

    @media ${media.small} {
        display: block;
    }
`;

export const HideForSmallOnly = css`
    @media ${media.medium} {
        display: none;
    }

    @media ${media.small} {
        display: none;
    }
`;

export default {
    ShowForMediumUp,
    HideForSmallOnly,
};
